import type { VideoExt } from '@photobooth/shared';

export interface NegotiatedMime {
  mime: string;
  ext: VideoExt;
}

const CANDIDATES: NegotiatedMime[] = [
  // Prefer MP4 so iOS can share/play out of the box.
  { mime: 'video/mp4;codecs=avc1.42E01E', ext: 'mp4' },
  { mime: 'video/mp4', ext: 'mp4' },
  { mime: 'video/webm;codecs=vp9,opus', ext: 'webm' },
  { mime: 'video/webm;codecs=vp8,opus', ext: 'webm' },
  { mime: 'video/webm;codecs=vp9', ext: 'webm' },
  { mime: 'video/webm;codecs=vp8', ext: 'webm' },
  { mime: 'video/webm', ext: 'webm' },
];

export interface NegotiateOptions {
  /** Override for testing. */
  isTypeSupported?: (mime: string) => boolean;
}

export function negotiateVideoMime(
  opts: NegotiateOptions = {},
): NegotiatedMime | null {
  const probe =
    opts.isTypeSupported ??
    (typeof MediaRecorder !== 'undefined'
      ? (m: string) => MediaRecorder.isTypeSupported(m)
      : () => false);
  for (const c of CANDIDATES) {
    if (probe(c.mime)) return c;
  }
  return null;
}

export function isMp4Preferred(mime: string): boolean {
  return mime.startsWith('video/mp4');
}
